var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconRotateLeftComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-rotate-left ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07885 2.69855L7.48219 0.961882C7.61552 0.868549 7.79885 0.961882 7.79885 1.12522V2.16522H9.13219C11.9289 2.16522 14.1989 4.43522 14.1989 7.23188V9.23188C14.1989 9.41855 14.0489 9.56522 13.8655 9.56522H13.0655C12.8822 9.56522 12.7322 9.41855 12.7322 9.23188V7.23188C12.7322 5.24522 11.1189 3.63188 9.13219 3.63188H7.79885V4.67522C7.79885 4.83855 7.61552 4.93522 7.48219 4.83855L5.07885 3.10522C4.94219 3.00522 4.94219 2.79855 5.07885 2.69855ZM9.46578 5.74398C10.3863 5.74398 11.1324 6.49017 11.1324 7.41064V13.4087C11.1324 14.3292 10.3863 15.0754 9.46578 15.0754H3.46773C2.54726 15.0754 1.80107 14.3292 1.80107 13.4087V7.41064C1.80107 6.49017 2.54726 5.74398 3.46773 5.74398H9.46578ZM9.79911 7.41064C9.79911 7.22655 9.64987 7.07731 9.46578 7.07731H3.46773C3.28364 7.07731 3.1344 7.22655 3.1344 7.41064V13.4087C3.1344 13.5928 3.28364 13.742 3.46773 13.742H9.46578C9.64987 13.742 9.79911 13.5928 9.79911 13.4087V7.41064Z",
    fillOpacity: "1"
  }));
}
var IconRotateLeft = /*#__PURE__*/React.forwardRef(IconRotateLeftComponent);
export default IconRotateLeft;